import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';

// import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";
import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import { SettingsMultipleTagSelectorV1Field } from "@core/custom-forms/components/fields/multiple-tag-selector-v1/settings-multiple-tag-selector-v1.class";

import { LabelsGroup } from '@core/objects/labels-group';
import { CoreCustomFormsService } from '@core/services/custom-forms/custom-forms.service';
import { KeySelectItem } from '@core/models/select-item.model';

import { FormsFieldItemMenuClick } from '../../../settings-field-menu/field-menu-item.model';
import { FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove } from '../../../settings-field-menu/fields.menu';

@Component({
    selector: 'form-field-settings-multiple-tag-selector-v1',
    templateUrl: './settings-multiple-tag-selector-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SettingsMultipleTagSelectorV1FieldComponent implements OnInit, OnChanges, OnDestroy{
    @Input() field: SettingsMultipleTagSelectorV1Field;
    @Output() fieldChange = new EventEmitter<SettingsMultipleTagSelectorV1Field>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();

    public placeholder: string = "Name of the Multiple Choice Tag field";
    public form: FormGroup = new FormGroup({});
    public fieldMenu: Array<ThreeDotsMenuItem> = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];
    public categories: Array<LabelsGroup>;
    public items: Array<KeySelectItem> = [];

    private subs: Subscription[] = [];

    constructor(private cdr: ChangeDetectorRef,private customFormsSrv: CoreCustomFormsService) {}

    ngOnInit(): void {
        this.subs.push(
            this.customFormsSrv.selectInitializedCategories().subscribe((initialized: boolean) => {
                if(!initialized){
                    this.customFormsSrv.loadCategories();
                }
            })
        );
        // this.updateMenuItems();
        this.subs.push(
            this.customFormsSrv.selectCategories().subscribe((categories: LabelsGroup[]) => {
                if(categories && categories.length > 0){
                    this.categories = categories;
                    this.init();
                }
            })
        )
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.field){
            this.cdr.markForCheck();
        }
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub: Subscription) => sub.unsubscribe());
    }

    protected init() {
        this.items = this.categories.map((c: LabelsGroup) => ({
            selected: this.field.categoryId ? this.field.categoryId.toString() === c.id.toString() : false,
            key: c.id.toString(),
            description: c.name,
            disabled: false
        }));
        this.cdr.markForCheck();
    }

    onSelectItem(item: KeySelectItem) {  
        let option = this.categories.filter((o: LabelsGroup)=> o.id == item.key);
        if(option)
            this.emit(this.field.update({ categoryId: option[0].id }));
    }

    onMandatoryChange(mandatory: boolean) {
        // Create a new object to ensure change detection
        this.field = this.field.update({ mandatory: mandatory});
        this.emit(this.field);;
    }

    onFieldChange(labelText: string) {
        this.emit(this.field.update({ label: labelText}));
    }

    onMenuClick(key: string) {
        // see ThreeDotsMenuItem interface definition to see how works this confirmation remove
        switch(key) {
            case "confirmation-remove":
                this.fieldMenu = [FieldsMenuMoveDown,  FieldsMenuMoveUp, FieldsMenuReallyRemove];
                break;
            case "dismiss-really-remove": // pseudo key to return to basic menu
                this.fieldMenu = [...FieldsStandardRemoveMenuItem, FieldsMenuMoveDown,  FieldsMenuMoveUp];
                break;
            default:
                const itemClicked: FormsFieldItemMenuClick = {key: key, field: this.field}
                this.menuClick.emit(itemClicked);
        }
    }

    private emit(updatedField: SettingsMultipleTagSelectorV1Field): void {
        this.fieldChange.emit(updatedField);
    }
}   